<template>
  <div>
  <div :id="showID" style="width: 100%;height:300px;"></div>
  </div>
</template>

<script>
import echarts from 'echarts'
export default {
    props: {
        statOrders: {
            type: Array,
            default: () => []
        },
        titleText:{
            type: String,
            default: () => "近5年数据"
        },
        showID:{
            type: String,
            default: () => "line1"
        },

        type:{
            type: String,
            default: () => "line"
        },
    },
  data() {
    return {
      myChart:null,
    }
  },
    // DOM 渲染完成触发
    mounted() {
        this.initData();
    },
  methods:{
        initData(){
            var that = this;
            var showDate = [];
            var nowData = [];
            if(that.statOrders != null) {
                that.statOrders.forEach(function (value, i) {
                  console.log(value);
                    showDate.push(value.year);
                    nowData.push(value.realAmount/100);
                });
            }
            var that = this;
            // 1. 基于准备好的dom，初始化echarts实例
            this.myChart = echarts.init(document.getElementById(that.showID))
            // 2. 发起请求，获取数据
            var option = {
                title: {
                    text: that.titleText
                },
                tooltip: {},
                legend: {
                    data:["年度数据"]
                },
                xAxis: {
                    data: showDate,
                },
                yAxis: {

                },
                series: [{
                    name: '年度数据',
                    type: that.type,
                    data: nowData
                }]
            };
            // 5. 使用刚指定的配置项和数据显示图表
            console.log(option);
            that.myChart.setOption(option);
        },

  },
  watch: {
      statOrders: {
          deep: true,
          handler(val) {
              this.initData()
          }
      },
      titleText: {
          deep: true,
          handler(val) {
              this.initData()
          }
      },
      type: {
          deep: true,
          handler(val) {
              this.initData()
          }
      }
  },

}
</script>




// WEBPACK FOOTER //
// src/pages/store/components/YearLineChart.vue